import styled from "styled-components";
import colors from "css/colors";

interface InputWrapperProps {
  disabled?: boolean;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  display: flex;
  flex-direction: column;

  input {
    font-size: 16px !important;
    border-radius: 6px;
    background-color: ${(props) => (props.disabled ? colors.GREY_BACKGROUND : "initial")};
  }

  .ant-input-number {
    border-radius: 6px;
  }

  .ant-input-number-disabled {
    background: ${colors.GREY_BACKGROUND};
  }
`;
